import moment from "moment";
import { useEffect, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { DatePicker } from "rsuite";
import { Modal, Spinner } from "reactstrap";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { toast } from "react-toastify";

export default function AddAttendanceRegularizationModal({ isOpen, onClose, EditArData = null, setState, getAr }) {
    const { register, handleSubmit, formState: { errors }, clearErrors, watch, reset, setValue, control } = useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [file, setFile] = useState({
        file: null,
        imageUrl: null,
        deleteUrl: null,
        isDelete: false
    });

    const onSubmit = (data) => {
        // console.log('Form Data:', data);
        const postData = {
            ...(EditArData !== null && { arRequestId: EditArData?.Arrequests[0]?.id }),
            attendanceStatus: 'pending',
            workType: data?.wrktyp,
            reason: data?.reason,
            checkInTime: `${data?.checkindate}T${data?.checkintime}`,
            checkOutTime: `${data?.checkoutdate}T${data?.chkout}`,
            document: file?.file,
            ...(file?.isDelete && { deleteDocument: file?.deleteUrl }),
        };

        const formData = new FormData();
        Object.keys(postData).forEach((key) => {
            const value = postData[key];
            if (value) { // Check if the value exists before appending
                formData.append(key, value);
            }
        });

        const option = {
            method: 'POST',
            form_data: formData, // Use 'body' for FormData
        };
        setIsLoading(true);

        const endPoint = EditArData !== null ? apiUrl.edit_ar : apiUrl.create_ar;
        // Call the API
        callApi(endPoint, option)
            .then((res) => {
                if (res?.status === true) {
                    toast.success(res?.message);
                    getAr();
                    setState((pre) => ({ ...pre, EditArData: null }));
                    onClose();
                    reset();
                } else {
                    toast.error(res?.message);
                }
            })
            .catch(() => {
                toast.error('An error occurred');
            })
            .finally(() => setIsLoading(false));

    }

    const handleDeleteDocument = () => {
        setFile((pre) => ({
            ...pre,
            file: null,
            imageUrl: null,
            isDelete: EditArData !== null ? !pre.isDelete : pre.isDelete
        }));
    }

    useEffect(() => {
        if (EditArData !== null) {
            const startDate = moment(EditArData?.checkInTime).format("YYYY-MM-DD");
            const endDate = moment(EditArData?.checkOutTime).format("YYYY-MM-DD");
            const checkInTime = EditArData?.checkInTime?.split("T")[1].split(":").slice(0, 2).join(":");
            const checkOutTime = EditArData?.checkOutTime?.split("T")[1].split(":").slice(0, 2).join(":");
            // console.log(EditArData?.checkInTime, EditArData?.checkOutTime);

            setValue('attsts', EditArData?.Arrequests[0]?.attendanceStatus);
            setValue('wrktyp', EditArData?.workType);
            setValue('reason', EditArData?.reasonAr);
            setValue('checkindate', startDate);
            setValue('checkoutdate', endDate);
            setValue('checkintime', checkInTime);
            setValue('chkout', checkOutTime);
            setFile((pre) => ({
                ...pre,
                imageUrl: EditArData?.document,
                deleteUrl: EditArData?.document
            }))
        } else {
            reset();
        }
    }, [EditArData, isOpen])


    return (
        <Modal
            className="modal-dialog modal-dialog-scrollable modal-dialog-centered ar-modal"
            isOpen={isOpen}
            toggle={() => {
                onClose();
                clearErrors();
                reset();
                setState((pre) => ({ ...pre, EditArData: null }));
            }
            }
        >
            <div className="modal-content">
                <div className="modal-header p-4 border-0">
                    <h1
                        className="modal-title fs-3 rajdhani-semibold"
                        id="attendanceModalLabel"
                    >
                        {EditArData !== null ? "Edit Regularization" : "Apply Regularization"}
                    </h1>
                    <button
                        type="button"
                        className="btn-close"
                        onClick={() => {
                            clearErrors()
                            reset()
                            setState((pre) => ({ ...pre, EditArData: null }));
                            onClose();
                        }}
                    />
                </div>
                <div className="modal-body p-4">
                    <form className="row" onSubmit={handleSubmit(onSubmit)} id="ArRequestForm">
                        {/* <div className="col-12">
                            <div className="form-group mb-3">
                                <label htmlFor="attsts" className="form-label">
                                    Attendance Status <span className="text-danger">*</span>
                                </label>
                                <select
                                    className="form-select"
                                    aria-label="Default select example"
                                    id="attsts"
                                    {...register("attsts", { required: "Attendance status is required" })}
                                >
                                    <option value="">Select Status</option>
                                    <option value="Present">Present</option>
                                    <option value="Absent">Absent</option>
                                    <option value="Half Day">Half Day</option>
                                </select>
                                {errors.attsts && <div className="text-danger">{errors.attsts.message}</div>}
                            </div>
                        </div> */}

                        <div className="col-12">
                            <div className="form-group mb-3">
                                <label htmlFor="wrktyp" className="form-label">
                                    Work Type <span className="text-danger">*</span>
                                </label>
                                <input
                                    className="form-control"
                                    aria-label="Default select example"
                                    id="wrktyp"
                                    {...register("wrktyp", { required: "Work type is required" })}
                                />
                                {/* <option value="">Select Work Type</option>
                                    <option value="Office">Office</option>
                                    <option value="Outdoor Duty">Outdoor Duty</option> */}
                                {errors.wrktyp && <div className="text-danger">{errors.wrktyp.message}</div>}
                            </div>
                        </div>

                        <div className="col-12">
                            <div className="form-group mb-3">
                                <label htmlFor="chkindate" className="form-label">
                                    Check In Date <span className="text-danger">*</span>
                                </label>
                                <Controller
                                    name="checkindate"
                                    control={control}
                                    rules={{
                                        required: "Check-in date is required",
                                        validate: (value) => {
                                            const checkDate = moment(value).startOf('day');
                                            const today = moment().startOf('day');
                                            if (checkDate.isAfter(today)) {
                                                return "Future dates are not allowed";
                                            }
                                            return true;
                                        }
                                    }}
                                    defaultValue={moment().format("YYYY-MM-DD")}
                                    render={({ field }) => (
                                        <DatePicker size="sm"
                                            {...field}
                                            id="chkindate"
                                            format="dd/MM/yyyy"
                                            oneTap
                                            placeholder="dd/mm/yyyy"
                                            style={{ width: "100%" }}
                                            value={field.value ? new Date(field.value) : null}
                                            onChange={(date) => {
                                                field.onChange(date ? moment(date).format("YYYY-MM-DD") : "");
                                            }}
                                            shouldDisableDate={(date) => date > new Date(moment().endOf('day'))}
                                            container={() => document.querySelector('.ar-modal .modal-content') || document.body}
                                            cleanable={false}
                                        />
                                    )}
                                />
                                {errors.checkindate && <div className="text-danger">{errors.checkindate.message}</div>}
                            </div>
                        </div>

                        <div className="col-12">
                            <div className="form-group mb-3">
                                <label htmlFor="chkintime" className="form-label">
                                    Check In Time <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="time"
                                    className="form-control"
                                    id="checkintime"
                                    {...register("checkintime", { required: "Check-in time is required" })}
                                />
                                {errors.checkintime && <div className="text-danger">{errors.checkintime.message}</div>}
                            </div>
                        </div>

                        <div className="col-12">
                            <div className="form-group mb-3">
                                <label htmlFor="chkoutdate" className="form-label">
                                    Check Out Date <span className="text-danger">*</span>
                                </label>
                                <Controller
                                    name="checkoutdate"
                                    control={control}
                                    rules={{
                                        required: "Check-out date is required",
                                        validate: (value) => {
                                            const checkin = watch("checkindate");
                                            if (checkin && moment(value).isBefore(moment(checkin))) {
                                                return "Check-out date cannot be before check-in date";
                                            }
                                            return true;
                                        }
                                    }}
                                    defaultValue={watch('checkindate') ? watch("checkindate") : moment().format("YYYY-MM-DD")}
                                    render={({ field }) => (
                                        <DatePicker size="sm"
                                            {...field}
                                            id="checkoutdate"
                                            format="dd/MM/yyyy"
                                            oneTap
                                            placeholder="dd/mm/yyyy"
                                            style={{ width: "100%" }}
                                            value={field.value ? new Date(field.value) : null}
                                            onChange={(date) => {
                                                field.onChange(date ? moment(date).format("YYYY-MM-DD") : "");
                                            }}
                                            shouldDisableDate={(date) => 
                                                watch('checkindate') && 
                                                date > new Date(moment(watch('checkindate')).endOf('day'))
                                            }
                                            container={() => document.querySelector('.ar-modal .modal-content') || document.body}
                                            cleanable={false}
                                        />
                                    )}
                                />
                                {errors.checkoutdate && <div className="text-danger">{errors.checkoutdate.message}</div>}
                            </div>
                        </div>

                        <div className="col-12">
                            <div className="form-group mb-3">
                                <label htmlFor="chkout" className="form-label">
                                    Check Out Time <span className="text-danger">*</span>
                                </label>
                                <input
                                    type="time"
                                    className="form-control"
                                    id="chkout"
                                    {...register("chkout", { required: "Check-out time is required" })}
                                />
                                {errors.chkout && <div className="text-danger">{errors.chkout.message}</div>}
                            </div>
                        </div>

                        <div className="col-12">
                            <div className="form-group mb-3">
                                <label htmlFor="desc" className="form-label">
                                    Reason <span className="text-danger">*</span>
                                </label>
                                <textarea
                                    className="form-control"
                                    rows={3}
                                    id="reason"
                                    placeholder="Enter Description here..."
                                    {...register("reason",
                                        // { required: "Reason is required" }
                                    )}
                                />
                                {errors.reason && <div className="text-danger">{errors.reason.message}</div>}
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="form-group mb-3">
                                <label htmlFor="desc" className="form-label">
                                    Attachment<span className="text-danger">*</span>
                                </label>
                                {!file?.imageUrl ? (
                                    <input
                                        type="file"
                                        className="form-control"
                                        id="desc"
                                        placeholder="Choose File"
                                        {...register('url',
                                            // { required: 'Attachment is required' }
                                        )}
                                        onChange={(e) => {
                                            const file = e.target.files[0];
                                            if (file && file.size > 6 * 1024 * 1024) {
                                                toast.error("File size must be less than 6MB");
                                                e.target.value = "";
                                                return;
                                            }
                                            const imageUrl = file ? URL.createObjectURL(file) : "";
                                            setFile((pre) => ({
                                                ...pre,
                                                file: file,
                                                imageUrl: imageUrl,
                                            }))
                                        }}
                                    />
                                ) : (
                                    <div className="d-flex justify-content-between align-items-center mt-2">
                                        <img src={file?.imageUrl} alt="" className="w-50" />
                                        <div className="">
                                            <button className="btn btn-danger btn-sm" onClick={() => {
                                                handleDeleteDocument()
                                            }}>Delete</button>
                                        </div>
                                    </div>
                                )}
                                {/* {errors.url && <div className="form-text text-danger">{errors.url.message}</div>} */}
                            </div>
                        </div>
                    </form>
                </div>
                <div className="modal-footer p-4 border-0">
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={() => {
                            clearErrors();
                            setFile((pre) => ({
                                ...pre,
                                file: null,
                                imageUrl: null,
                            }));
                            setState((pre) => ({ ...pre, EditArData: null }));
                            reset();
                            onClose();
                        }}
                    >
                        Close
                    </button>
                    <button type="submit" className="btn btn-primary" form="ArRequestForm">
                        {isLoading ? <Spinner /> : EditArData !== null ? "Update" : "Apply"}
                    </button>
                </div>
            </div>
        </Modal>

    )
}
